import { omit } from 'lodash';

import {
  RENTAL_AGREEMENT,
  CONTRACT_TYPE,
  R2R_USER_ID,
} from '../../../../shared/constants';
import { IUser } from '../../../../shared/ts/user';
import { IListingDetailForm } from '../ListingDetailForm.types';

export const getContractTypeOptions = (
  values: IListingDetailForm,
  user: IUser | null,
) => {
  if (user?.id === R2R_USER_ID) {
    return [CONTRACT_TYPE.TEMPORARY_RENT_TO_RENT].map(({ label, value }) => ({
      label,
      value,
    }));
  } else if (
    values?.rental_agreement?.value === RENTAL_AGREEMENT.AGREED_FEE.value
  ) {
    return [
      CONTRACT_TYPE['3+2'],
      CONTRACT_TYPE.TEMPORARY,
      CONTRACT_TYPE.TEMPORARY_STUDENT,
    ].map(({ label, value }) => ({
      label,
      value,
    }));
  } else if (
    values?.rental_agreement?.value === RENTAL_AGREEMENT.FREE_FEE.value
  ) {
    return [CONTRACT_TYPE['4+4'], CONTRACT_TYPE.TEMPORARY].map(
      ({ label, value }) => ({
        label,
        value,
      }),
    );
  } else {
    return Object.values(omit(CONTRACT_TYPE, ['TEMPORARY_RENT_TO_RENT'])).map(
      ({ label, value }) => ({
        label,
        value,
      }),
    );
  }
};
